export default ({ Vue, app }) => {
  Vue.filter('tax', (taxType) => {
    if (taxType === undefined || taxType === null || taxType === '') return '';
    return app.i18n.t(`filters.tax.${taxType}`);
  });
};
